import { localStorageKeys } from 'src/app/services/localStorage/localStorageVariables';
import { LocalStorageService } from './../../../services/localStorage/localStorage.service';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { AccountService } from 'src/app/services/user/account.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-prime-toggle-bar',
  templateUrl: './prime-toggle-bar.component.html',
  styleUrls: ['./prime-toggle-bar.component.scss']
})
export class PrimeToggleBarComponent implements OnChanges {
  @Input() isPrimeEnabled: boolean = false;
  @Input() offers: any;
  @Input() campaigns: any;
  @Output() primeToggled = new EventEmitter<boolean>();
  @Output() getPrimeDiscount = new EventEmitter<void>();
  public enabledOffer: any;
  public enabledCampaign: any;
  userType: string;

  constructor(private localStorageService: LocalStorageService, private accountService: AccountService, private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.userType = this.localStorageService.getItem(localStorageKeys.USER_TYPE);
    this.getOfferData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isPrimeEnabled'] || changes['offers'] || changes['campaigns']) {
      this.getOfferData();
    }
  }

  togglePrime() {
    this.isPrimeEnabled = !this.isPrimeEnabled;
    this.localStorageService.setItem(localStorageKeys.IS_PRIME_TOGGLE_ENABLED, JSON.stringify(this.isPrimeEnabled));
    this.getOfferData();
    this.primeToggled.emit(this.isPrimeEnabled);
  }

  onGetPrimeDiscount() {
    this.getPrimeDiscount.emit();
    this.analyticsService.trackUnified('prime_discount_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Prime Discount Button Clicked',
      button: 'prime-discount-button',
    });
  }

  getOfferData(){
    // Flights-v2: pick the active offer matching the current prime tier.
    const tierType = this.isPrimeEnabled ? 'PRIME' : 'NONPRIME';
    const matchingOffers = this.offers?.filter(
      (o: any) => o?.active && o?.tierType === tierType
    );
    this.enabledOffer = matchingOffers?.length > 0 ? matchingOffers[0] : null;
    const campaignSlug = this.isPrimeEnabled ? 'bfl-prime' : 'bfl-non-prime';
    const matchingCampaigns = this.campaigns?.filter(
      (c: any) => c?.campaignSlug === campaignSlug
    );
    this.enabledCampaign = matchingCampaigns?.length > 0 ? matchingCampaigns[0] : null;
  }
}
